module.exports = __webpack_public_path__ + "dist/assets/img/header_developpement.b95b45c9.jpg";